import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import appConfig from '../../config/config';
import {
    Card, CardBody,
    Modal, ModalHeader, ModalBody, ModalFooter,
    CardTitle, Form, Row, FormGroup, Button, Col, Input
} from 'reactstrap';
import { connect } from 'react-redux';
import axios from 'axios';
import { renderInput } from '../common/renderinput';

 class SearchNoteForm extends Component {
    constructor(props) {
        super(props);
        this.state = {display:true}
    }
    handleSearch = (values) => {
        //Use axios to send request
        this.props.loading(true);
        axios.post(
            appConfig.apiGateway.searchOrderUrl,
            JSON.stringify({ OrderProductId: this.props.OrderProductId, Action: "OrderNote" }),
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.props.session.session.credentials.accessToken}`
                }
            }
        ).then(response => {
            this.props.loading(false);
            this.props.complete(JSON.parse(response.data.body));
        }, error => {
            this.props.loading(false);
        });
    }
       render() {
            return (
            <>
                 <Card className="w-100">
                     <CardBody>
                         <CardTitle>Search Criteria</CardTitle>
                         <form onSubmit={this.props.handleSubmit(this.handleSearch)}>
                             <Row form>
                                 <Col md={5}>
                                     <FormGroup>
                                         <Field name="searchNoteParam" component={renderInput} placeholder="Order" />
                                     </FormGroup>
                                 </Col>
                                 <Col md={5}>
                                     <FormGroup>
                                         <Button color="primary" >Search</Button>
                                         <Button className="ml-3" >Reset</Button>
                                         <Button type="button" className="ml-3" color="primary" onClick={()=> this.props.Add(true)} >Add</Button>
                                     </FormGroup>
                                 </Col>
                             </Row>
                         </form>
                     </CardBody>
                 </Card>
             </>
         );
     }
 }
 const validate = (formvalues) => {
 }
 const mapStatetoProps = state => {
     return { session: state.session }
 }
 var searchNoteForm = reduxForm({
     form: 'searchOrderNoteform',
     validate
 })(SearchNoteForm);
 searchNoteForm = connect(mapStatetoProps)(searchNoteForm);
 export default searchNoteForm





